// @flow

import styled from 'styled-components/macro';

const Body = styled.tbody`
  padding: 0;
`;

export default Body;
